import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { NovedadesVinculacionDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';



import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class NovedadesVinculacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEnvioCorreoElectronicoPorUsuarioService(usuario: string): Observable<BodyListResponse<NovedadesVinculacionDTO>> {
    return this.http.get<BodyListResponse<NovedadesVinculacionDTO>>(API_URL + '/api/v1/novedadesVinculacion/usuario/' + usuario);
  }

  getEnvioCorreoElectronicoPorNumeroIdService(numeroIdentificacion: string): Observable<BodyListResponse<NovedadesVinculacionDTO>> {
    return this.http.get<BodyListResponse<NovedadesVinculacionDTO>>(API_URL + '/api/v1/novedadesVinculacion/numeroId/' + numeroIdentificacion);
  }

  getNovedadesRecibidas(numeroIdentificacion: string): Observable<BodyListResponse<NovedadesVinculacionDTO>> {
    return this.http.get<BodyListResponse<NovedadesVinculacionDTO>>(API_URL + '/api/v1/novedadesVinculacion/recibida/' + numeroIdentificacion);
  }

  getEnvioCorreoElectronicoService(): Observable<BodyListResponse<NovedadesVinculacionDTO>> {
    return this.http.get<BodyListResponse<NovedadesVinculacionDTO>>(API_URL + '/api/v1/novedadesVinculacion/todos');
  }

  guardarEnvioCorreoElectronicoService(NovedadesVinculacionDTO: NovedadesVinculacionDTO): Observable<BodyResponse<NovedadesVinculacionDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/novedadesVinculacion', NovedadesVinculacionDTO);
  }

  guardarListRegistroNovedades(lista: NovedadesVinculacionDTO[]): Observable<BodyResponse<NovedadesVinculacionDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/novedadesVinculacion/guardarLista', new BodyListResponse(lista, lista.length));
  }

  getEnvioCorreoElectronicoPorCodigoService(codigo: string): Observable<BodyResponse<NovedadesVinculacionDTO>> {
    return this.http.get<BodyResponse<NovedadesVinculacionDTO>>(API_URL + '/api/v1/novedadesVinculacion/' + codigo);
  }
}
